import { useSelector } from 'react-redux'
import { BackArrow } from 'app/containers/widget/launcher/components'
import DepartmentLogo from 'app/components/DepartmentLogo'
import CloseWidgetBtn from 'app/components/CloseWidgetBtn'

import './header.scss'

const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

function Header({ department }) {
  const languageInfo = useSelector(getLanguageInfo)
  const departmentOperators = department.operators
  const isTeamOnline = departmentOperators.some((op) => op.online)

  const renderOnlineStatusText = () => {
    if (isTeamOnline) {
      return languageInfo.texts.online
    }

    return languageInfo.texts.offline
  }

  return (
    <div className="chat_header_team_wrapper">
      <div className="chat_header_team">
        <div className="chat_header_team_info">
          <div className="team_avatar_wrapper">
            <DepartmentLogo
              logo={department.logo}
              name={department.name}
              operators={department.operators}
              showTooltip={true}
            />
          </div>

          <div className="chat_header_details">
            <div className="team_title">{department.name}</div>
            <div className="team_online_status">{renderOnlineStatusText()}</div>
          </div>
        </div>
        <div className="chat_header_actions">
          <CloseWidgetBtn />

          <BackArrow />
        </div>
      </div>
    </div>
  )
}

export default Header
